export default "__VITE_ASSET__be7f946a__"